/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "@hooks/useDevice";
/* -----------------UI--------------- */
import { Redirect } from "expo-router";
import { useFocusEffect } from "expo-router";
import { useCallback } from "react";

import { AppBottomTabs } from "@features/dashboard/layouts/AppBottomTabs";
import { AppDrawer } from "@features/dashboard/layouts/AppDrawer";
/* -----------------Types--------------- */
import { replayManager } from "@helpers/lib/sentry";
import { isWeb } from "@helpers/platform";
import useClerkUser from "@hooks/useClerkUser";

const DashboardLayout = () => {
	const { isMobile } = useDevice();
	const { isSignedIn, isLoaded } = useClerkUser();

	useFocusEffect(
		useCallback(() => {
			replayManager().stopReplay();
		}, []),
	);

	if (isLoaded && !isSignedIn) {
		return <Redirect href="/" />;
	}

	return <>{isMobile && !isWeb ? <AppBottomTabs /> : <AppDrawer />}</>;
};

export default DashboardLayout;
